// extracted by mini-css-extract-plugin
export var container = "_d5-0";
export var icon = "_d5-1";
export var text = "_d5-2";